<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <div class="card-icon">
        <md-icon>hotel</md-icon>
      </div>
      <h4 class="title">
        Accommodation
      </h4>
      <md-button
        class="md-dense md-primary"
        @click="addAllDays()"
        style="margin-top: 1rem"
      >
        <md-icon>add</md-icon>
        Create all Dates
      </md-button>
      <md-button
        class="md-dense md-primary"
        @click="addDay()"
        style="margin-top: 1rem"
      >
        <md-icon>add</md-icon>
        Add a Reservation
      </md-button>
    </md-card-header>
    <md-card-content>
      <md-table v-model="sortedReservations">
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="Date">
            <md-datepicker
              v-model="item.date"
              md-immediately
              :md-model-type="String"
            >
            </md-datepicker>
          </md-table-cell>
          <md-table-cell md-label="Day">
            {{ item.date | getDayFromDate }}
          </md-table-cell>
          <md-table-cell md-label="Hotel">
            <md-field class="option-select">
              <md-input
                :value="getReservationSearch(item)"
                :list="accommodationListId"
                @input="setReservationSearch(item, $event)"
                @change="applyReservationSearch(item)"
                @blur="applyReservationSearch(item)"
              ></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell
            md-label="T"
            md-tooltip="Twin Room"
            class="small-number"
            style="width:5%"
          >
            <md-field>
              <md-input v-model="item.room_type_twin" type="text"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell
            md-label="D"
            md-tooltip="Double Room"
            class="small-number"
            style="width:5%"
          >
            <md-field>
              <md-input v-model="item.room_type_double" type="text"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell
            md-label="S"
            md-tooltip="Single Room"
            class="small-number"
            style="width:5%"
          >
            <md-field>
              <md-input v-model="item.room_type_single" type="text"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell
            md-label="F"
            md-tooltip="Family Room"
            class="small-number"
            style="width:5%"
          >
            <md-field>
              <md-input v-model="item.room_type_family" type="text"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell md-label="Notes">
            <md-field>
              <md-input v-model="item.notes" type="text"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell md-label="Booked">
            <md-switch v-model="item.booked"></md-switch>
          </md-table-cell>
          <md-table-cell md-label="Paid">
            <md-switch v-model="item.paid"></md-switch>
          </md-table-cell>
          <md-table-cell>
            <md-button
              class="md-danger md-just-icon md-simple"
              @click.stop="removeItem(item)"
            >
              <md-icon>delete</md-icon>
              <md-tooltip md-direction="top">Remove Entry</md-tooltip>
            </md-button>
          </md-table-cell>
        </md-table-row>
        <md-table-empty-state
          md-label="Nothing to Show"
          :md-description="`We can't find any details to show.`"
        >
        </md-table-empty-state>
      </md-table>
      <datalist :id="accommodationListId">
        <option
          v-for="accom in accommodation"
          :key="accom.id"
          :value="accom.company"
        ></option>
      </datalist>
      <md-button
        class="md-dense md-primary"
        @click="save"
        style="margin-top: 1rem"
      >
        <md-icon>save</md-icon>
        Save
      </md-button>
    </md-card-content>
  </md-card>
</template>

<script>
import departureApi from "@/services/api/departure";
import accomApi from "@/services/api/accom";
import moment from "moment";
import { getMissingDepartureDates } from "@/helpers/reservations";

export default {
  props: {
    manifest: {
      itinerary: [],
      dinners: [],
      reservations: []
    },
    departure: {}
  },

  data() {
    return {
      accommodation: [],
      reservationSearchMap: new WeakMap()
    };
  },

  computed: {
    accommodationListId() {
      return `accommodation-list-${this._uid}`;
    },

    sortedReservations() {
      return this.manifest.reservations
        .slice()
        .sort((a, b) => Date.parse(a.date) - Date.parse(b.date));
    }
  },

  methods: {
    addAllDays() {
      const existingDates = (this.manifest.reservations || []).map(
        reservation => reservation.date
      );
      getMissingDepartureDates(
        this.departure.start_date,
        this.departure.end_date,
        existingDates
      ).forEach(this.addDay);
    },

    addDay(date = null) {
      this.manifest.reservations.push({
        date: date ? moment().format(date) : moment().format("YYYY-MM-DD"),
        accommodation_id: null,
        notes: ""
      });
    },

    removeItem: function(item) {
      this.manifest.reservations.splice(
        this.manifest.reservations.indexOf(item),
        1
      );
    },

    setReservationSearch(item, value) {
      this.reservationSearchMap.set(item, value);
    },

    getReservationSearch(item) {
      if (this.reservationSearchMap.has(item)) {
        return this.reservationSearchMap.get(item);
      }
      if (!item.accommodation_id || !this.accommodation.length) return "";
      const match = this.accommodation.find(
        accom => accom.id === item.accommodation_id
      );
      return match ? match.company : "";
    },

    applyReservationSearch(item) {
      const search = (this.getReservationSearch(item) || "")
        .trim()
        .toLowerCase();
      if (!search) {
        item.accommodation_id = null;
        return;
      }
      const match = this.accommodation.find(
        accom => accom.company?.toLowerCase() === search
      );
      item.accommodation_id = match ? match.id : null;
    },

    save() {
      this.manifest.reservations.forEach(reservation => {
        this.applyReservationSearch(reservation);
      });
      departureApi
        .updateManifest(this.departure.id, this.manifest)
        .then(response => {
          this.$emit("manifestChanged", response.data.manifest);
          this.$notify({
            timeout: 2500,
            message: "Updated.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        });
    }
  },

  created() {
    accomApi.getAccoms().then(response => {
      this.accommodation = response.data || [];
    });
  }
};
</script>

<style lang="scss">
.small-number {
  width: 100px;
}
</style>
